// extracted by mini-css-extract-plugin
export var body = "faq-module--body--9z5Lq";
export var buttonContainer = "faq-module--buttonContainer--sK7GH";
export var faq = "faq-module--faq--b6ZQI";
export var header = "faq-module--header--31h6s";
export var imageContainer = "faq-module--imageContainer--DzKnR";
export var left = "faq-module--left--5Xt1-";
export var mainText = "faq-module--mainText--U82st";
export var noImage = "faq-module--noImage--R2vTq";
export var reverse = "faq-module--reverse--pXNLm";
export var sbShowMain = "faq-module--sb-show-main--4OzpV";
export var step = "faq-module--step--UA7oK";
export var steps = "faq-module--steps--uQoBx";
export var text = "faq-module--text--Cejkk";